import React from "react";
import { Navigate } from "react-router-dom";

const MEMBER_HOME = "/blogs/premium/";

const CheckLogin = () => {
  if (localStorage.getItem("session") !== null) {
    return <Navigate to={MEMBER_HOME} replace />;
  }
  return null;
};

export default CheckLogin;
